import { useMutation, UseMutationResult } from "react-query";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { giftcardsApiV2 } from "../api/giftcardsApiV2";

export interface UseLoadGiftCardFileStockProps {
    payload: FormData;
}

export default function useLoadGiftCardFileStock({
    ...options
}: UseCustomMutationOptions<void, unknown, UseLoadGiftCardFileStockProps>): UseMutationResult<
    void,
    unknown,
    UseLoadGiftCardFileStockProps
> {
    return useMutation(
        async ({ payload }: UseLoadGiftCardFileStockProps) => {
            await giftcardsApiV2.loadGiftCardFileStock(payload);
        },
        { ...options },
    );
}
